export function reportProducts(products = [], details = {}) {
  return products.map(product => {
    const selected = details[product.id] || {};
    const quantity = Math.max(1, Math.trunc(Number(selected.quantity ?? product.quantity) || 1));
    const value = selected.price ?? product.price;
    const price = value === null || value === undefined || value === "" ? null : Number(value);
    return { ...product, quantity, price: Number.isFinite(price) ? price : null, total: Number.isFinite(price) ? price * quantity : null };
  });
}

export function reportProductsTotal(products) {
  return products.length && products.every(product => product.total !== null)
    ? products.reduce((sum, product) => sum + product.total, 0)
    : null;
}
